




















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { timeout } from '@/utils/common'

@Component
export default class ViewFinanceiroEspecialidadeProcedimento extends Vue {
  itemMode: string = 'CREATE'

  loadEditar: any = ''
  get loadingEditar() { return this.loadEditar }
  set loadingEditar(value: any) { this.loadEditar = value }

  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  loadDelete: boolean = false
  get loadingDelete() { return this.loadDelete }
  set loadingDelete(value: boolean) { this.loadDelete = value }

  itemToDelete: any = ''
  get itemToDeleteId() { return this.itemToDelete }
  set itemToDeleteId(value: any) { this.itemToDelete = value }

  modalDelete: boolean = false
  get showModalDelete() { return this.modalDelete }
  set showModalDelete(value: boolean) { this.modalDelete = value }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get tableHeaders() {
    return [
      { text: 'Especialidade', value: 'especialidadeId', align: 'left', sortable: false },
      { text: 'Subespecialidade', value: 'subEspecialidadeId', align: 'left', sortable: false },
      { text: 'Código do procedimento', value: 'codigoProcedimento', align: 'left', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get itemsEspecialidadeProcedimento() {
    return this.getFinanceiroStore.itemsEspecialidadeProcedimento
  }

  get itemsEspecialidade() {
    return this.getFinanceiroStore.itemsEspecialidade
  }

  get subEspecialidadesFiltradas() {
    if (!this.filtroEspecialidadeId) return this.getFinanceiroStore.itemsSubEspecialidade
    return this.getFinanceiroStore.itemsSubEspecialidade.filter((s: any) => s.especialidadeId === this.filtroEspecialidadeId)
  }

  get filtroEspecialidadeId() {
    return this.getFinanceiroStore.filtroEspecialidadeIdProc
  }

  set filtroEspecialidadeId(value: any) {
    this.getFinanceiroStore.setFiltroEspecialidadeIdProc(value)
  }

  get filtroSubEspecialidadeId() {
    return this.getFinanceiroStore.filtroSubEspecialidadeIdProc
  }

  set filtroSubEspecialidadeId(value: any) {
    this.getFinanceiroStore.setFiltroSubEspecialidadeIdProc(value)
  }

  get filtroCodigoProcedimento() {
    return this.getFinanceiroStore.filtroCodigoProcedimento
  }

  set filtroCodigoProcedimento(value: string) {
    this.getFinanceiroStore.setFiltroCodigoProcedimento(value || '')
  }

  nomeEspecialidade(id: any) {
    const esp = this.itemsEspecialidade.find((e: any) => e.id === id)
    return esp ? esp.descricao : '-'
  }

  nomeSubEspecialidade(id: any) {
    if (!id) return '-'
    const sub = this.getFinanceiroStore.itemsSubEspecialidade.find((s: any) => s.id === id)
    return sub ? sub.descricao : '-'
  }

  onFiltroEspecialidadeChange() {
    this.filtroSubEspecialidadeId = null
    this.getAllItems()
  }

  criarItem() {
    this.itemMode = 'CREATE'
    this.getFinanceiroStore.clearItemEspecialidadeProcedimento()
    this.getFinanceiroStore.setModal({ name: 'criarEditarEspecialidadeProcedimento', value: true })
  }

  async editarItem(item: any) {
    this.itemMode = 'EDIT'
    this.getFinanceiroStore.clearItemEspecialidadeProcedimento()
    this.loadingEditar = item.id
    await timeout(500)
    this.getFinanceiroStore.setOriginalItemEspecialidadeProcedimento({ ...item })
    this.getFinanceiroStore.setItemEspecialidadeProcedimento({ ...item })
    this.getFinanceiroStore.setModal({ name: 'criarEditarEspecialidadeProcedimento', value: true })
    this.loadingEditar = ''
  }

  async apagarItem() {
    this.loadingDelete = true
    const response = await this.getFinanceiroStore.deleteEspecialidadeProcedimento(this.itemToDeleteId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `Vínculo apagado com sucesso! ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
      this.showModalDelete = false
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1f615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingDelete = false
  }

  async getAllItems() {
    this.loadingDataTable = true
    this.getPagina = 1
    await this.getFinanceiroStore.getAllEspecialidadeProcedimento()
    this.loadingDataTable = false
  }

  setItemToDelete(id: any) {
    this.itemToDeleteId = id
    this.showModalDelete = !this.showModalDelete
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    this.getFinanceiroStore.clearItemsEspecialidadeProcedimento()
    this.getFinanceiroStore.clearItemEspecialidadeProcedimento()
    await this.getFinanceiroStore.getAllEspecialidade()
    await this.getFinanceiroStore.getAllSubEspecialidade()
    await this.getAllItems()
    this.$ga.event('financeiro', 'acessar-especialidade-procedimento', this.$user.profile.email)
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }

  get itemsLength() {
    return Math.ceil(this.getFinanceiroStore.itemsEspecialidadeProcedimentoTotal / this.getFinanceiroStore.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getFinanceiroStore.itemsEspecialidadeProcedimentoPagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setItemsEspecialidadeProcedimentoPagina(value)
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.getFinanceiroStore.getAllEspecialidadeProcedimento()
    this.loadingDataTable = false
  }

  @Watch('showModalDelete')
  onChangeShowModalDelete(value) {
    if (!value) this.itemToDeleteId = ''
  }
}
